export default function FooterContainer() {
  return <>
    Beefteka, Browar Koło - panel zarządzania treścią. Stworzone przez <a href="https://digimuth.com">Digimuth</a>
  </>;
}